'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _create = require('babel-runtime/core-js/object/create');

var _create2 = _interopRequireDefault(_create);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _commonMenu = require('./commonMenu');

var _commonMenu2 = _interopRequireDefault(_commonMenu);

var _primaryMenuItemBuilder = require('./primaryMenuItemBuilder');

var _primaryMenuItemBuilder2 = _interopRequireDefault(_primaryMenuItemBuilder);

var _primaryMenuItemActiveNarrow = require('./primaryMenuItemActiveNarrow');

var _primaryMenuItemActiveNarrow2 = _interopRequireDefault(_primaryMenuItemActiveNarrow);

var _rpMqBreakpoints = require('rp-mq-breakpoints');

var _rpMqBreakpoints2 = _interopRequireDefault(_rpMqBreakpoints);

var _rpAnalytics = require('rp-analytics');

var segmentio = _interopRequireWildcard(_rpAnalytics);

var _rpUtils = require('rp-utils');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Primary Menu
 * @augments CommonMenu
 * @constructor
 */
function PrimaryMenu() {
    _commonMenu2.default.prototype.constructor.apply(this, arguments);

    this.activeItemNarrow = new _primaryMenuItemActiveNarrow2.default('#primaryCurrent');

    this.itemBuilder = new _primaryMenuItemBuilder2.default();
    this.itemSelector = '.rn-primaryNav__item';

    this.moreItemSelector = '#primaryMoreItem';
    this.moreItemLinkSelector = '#primaryMoreLink';

    this.hamburgerMenuButtonTabletSelector = '#userMenuBtnTablet';

    this.$moreItem = (0, _jquery2.default)(this.moreItemSelector);
    this.$moreItemLink = (0, _jquery2.default)(this.moreItemLinkSelector);

    this.$secondaryPointer = (0, _jquery2.default)('.rn-secondaryNav__pointer');
    this.$hamburgerMenuButton = (0, _jquery2.default)('#userMenuBtn');
    this.$hamburgerMenu = (0, _jquery2.default)('#hamburgerMenu');
    this.$hamburgerMenuNextRaceItem = (0, _jquery2.default)('#hamburgerMenu-nextRaceItem');
    this.$hamburgerMenuNextRaceLink = (0, _jquery2.default)('.js-nextRaceLink');
    this.$hamburgerMenuNextRaceSpanUnavailable = (0, _jquery2.default)('.js-nextRaceSpanUnavailable');
    this.$hamburgerMenuNextRaceTimeLeft = (0, _jquery2.default)('.js-nextRaceTimeLeft');
    this.$hamburgerMenuNextRaceTimeAndCourse = (0, _jquery2.default)('.js-nextRaceTimeAndCourse');
    this.$freeBetsAnchors = (0, _jquery2.default)('.freeBets__Anchor');

    this.$popover = (0, _jquery2.default)('.rn-primaryNav__popover');
    this.$popoverList = (0, _jquery2.default)('.rn-primaryNav__popover__list');
    this.$parent = (0, _jquery2.default)('body');
    this.$overlay = (0, _jquery2.default)('<div class="ui-overlay" />');
    this.$overlayFrom = (0, _jquery2.default)('<body>');

    this.itemClassPreRender = 'rn-primaryNav__item_preRender';
    this.primaryActiveClass = 'rn-primaryNav_active';
    this.hamburgerMenuActiveClass = 'rn-hamburgerMenu--active';
    this.hamburgerMenuLinkHiddenClass = 'rn-hamburgerMenu__link--hidden';

    this.primaryNavMoreLinkActiveClass = 'rn-primaryNav__more__link--active';
    this.btnMajorClass = 'ui-btn_primary';
    this.linkUiClass = 'ui-link';
    this.morePopoverClass = 'rn-primaryNav__popover_active';
    this.isAnchorInNavigation = 'freeBets__Anchor--in-navigation';

    this.firstClickPrimary = false;
    this.openedPrimary = false;
    this.firstClickMore = false;
    this.openedMore = false;

    this.init();
} /* eslint-disable prefer-arrow-callback */
/**
 * @module navigation/primaryMenu
 * @requires module: navigation/commonMenu
 * @requires module: navigation/primaryMenuItemBuilder
 * @author: Serhii Atiahin [serhii.atiahin@racingpost.com]
 */

PrimaryMenu.prototype = (0, _create2.default)(_commonMenu2.default.prototype);

/**
 * @inheritdoc
 */
PrimaryMenu.prototype.setActiveItem = function (menuItem) {
    /**
     * Deactivate previously active item
     */
    var activeItem = this.getActiveItem();
    if (activeItem) {
        activeItem.isActive = false;
        activeItem.render();
    }

    /**
     * Skip "More" item, just change a position of pointer
     */
    if (menuItem.$obj.is(this.moreItemSelector)) {
        this.getNavigationContainer().trigger('changePointerPosition.secondaryNav', this._getItemPointerPosition(this.$moreItem));
        return this;
    }

    /**
     * Mark item to active after next render
     */
    _commonMenu2.default.prototype.setActiveItem.call(this, menuItem);

    /**
     * Apply changes to DOM
     */
    menuItem.render();

    this._changeSecondaryPointerPosition();

    return this;
};

/**
 * Bind events
 * @private
 */
PrimaryMenu.prototype._bindEvents = function () {
    var self = this;

    (0, _jquery2.default)(document).ready(this._onDocumentReadyHandler());

    (0, _jquery2.default)(window).on('load', this._onWindowLoadHandler()).on('orientationchange', this._onWindowResizeHandler()).resize(this._onWindowResizeHandler()).on('rpBreakpointsSwitch', this._onSwitchBreakpointsHandler()).on('scroll', this._onWindowScrollHandler());

    (0, _jquery2.default)('.rn-primaryNav').on('click', function (event) {
        var $target = (0, _jquery2.default)(event.target);
        if ($target.hasClass('rn-primaryNav__label')) {
            // eslint-disable-next-line max-len
            segmentio.trackNavigationClick((0, _defineProperty3.default)({}, segmentio.TRAIT_SELECTION, $target.text().trim())).then(function () {
                console.log($target.text().trim());
            });
        }
    });

    this.$hamburgerMenuButton.on('click touchstart', function (event) {
        event.preventDefault();
        if (!self.openedPrimary) {
            self.firstClickPrimary = true;
            self._openHamburgerMenu();
        }
    });

    /**
     * Bind topMenu click tracking event on link
     */
    (0, _jquery2.default)('.rn-topMenu__item').on('click', function (event) {
        var currentTargetTextSection = (0, _jquery2.default)(event.currentTarget).attr('data-text');

        segmentio.trackNavigationClick((0, _defineProperty3.default)({}, segmentio.TRAIT_SELECTION, currentTargetTextSection));
    });

    /**
     * Bind topMenu click tracking event on link
     */
    (0, _jquery2.default)('.rn-primaryNavMobile__link').on('click', function (event) {
        var currentTargetTextSection = (0, _jquery2.default)(event.currentTarget).attr('data-text');

        segmentio.trackNavigationClick((0, _defineProperty3.default)({}, segmentio.TRAIT_SELECTION, currentTargetTextSection));
    });

    /**
     * Bind hamburger click tracking.
     */
    (0, _jquery2.default)('.rn-hamburgerMenu').on('click', function (event) {
        var $target = (0, _jquery2.default)(event.target);
        // eslint-disable-next-line max-len
        if ($target.hasClass('rn-hamburgerMenu__link') && $target.parent().attr('id') !== 'hamburgerMenu-moreItem') {
            // eslint-disable-next-line max-len
            segmentio.trackNavigationClick((0, _defineProperty3.default)({}, segmentio.TRAIT_SELECTION, $target.text().trim())).then(function () {
                console.log($target.text().trim());
            });
        }
    });

    this.$obj.on('click touchstart', this.hamburgerMenuButtonTabletSelector, function (event) {
        event.preventDefault();
        if (!self.openedPrimary) {
            self.firstClickPrimary = true;
            self._openHamburgerMenu();
        }
    });

    this.$obj.on('click touchstart', this.moreItemLinkSelector, function (event) {
        event.preventDefault();
        if (!self.openedMore) {
            self.firstClickMore = true;
            self._openMorePopover();
        }
    });

    this._startMenuSizeTracking();
    this.freeBets();
};

PrimaryMenu.prototype._startMenuSizeTracking = function () {
    var _this = this;

    var handler = this._onWindowResizeHandler();
    var width = this.$obj.width();
    this.interval = setInterval(function () {
        var newWidth = _this.$obj.width();
        if (newWidth !== width) {
            handler();
            width = newWidth;
        }
    }, 50);
};

PrimaryMenu.prototype._stopMenuSizeTracking = function () {
    clearInterval(this.interval);
    this.interval = null;
};

/**
 * @returns {Function}
 * @private
 */
PrimaryMenu.prototype._onDocumentReadyHandler = function () {
    var self = this;

    self._hamburgerMenuNextRace();

    return function () {
        self.render();

        self.updatePrimaryNavItems();
        self.updateHamburgerMenuItems();
    };
};

/**
 * @returns {Function}
 * @private
 */
PrimaryMenu.prototype._onWindowLoadHandler = function () {
    var self = this;

    return function () {
        self.render();
        self._restoreOverflow();
    };
};

/**
 * @returns {Function}
 * @private
 */
PrimaryMenu.prototype._onWindowResizeHandler = function () {
    var self = this;

    return function (event) {
        self._changeSecondaryPointerPosition.call(self, event);
        self.render();
    };
};

/**
 * @returns {Function}
 * @private
 */
PrimaryMenu.prototype._onSwitchBreakpointsHandler = function () {
    var self = this;

    return function (event) {
        var breakpointCode = event.detail.breakpoint.code;

        if (self.openedPrimary) {
            self._positionOverlay();
        }

        if (!['xn', 'n'].includes(breakpointCode)) {
            if (self.openedPrimary) {
                self._closeHamburgerMenu();
            }

            self._renderMoreMenu();
        }

        if (self.openedMore && ['xn', 'n'].includes(breakpointCode)) {
            self._closeMorePopover();
        }
    };
};

/**
 * @returns {Function}
 * @private
 */
PrimaryMenu.prototype._onWindowScrollHandler = function () {
    var self = this;
    return function () {
        if (self.openedPrimary) {
            self._positionOverlay();
        }
    };
};

/**
 * @inheritdoc
 */
PrimaryMenu.prototype.render = function () {
    this.getRenderedItems().removeClass(this.itemClassPreRender);

    _commonMenu2.default.prototype.render.apply(this, arguments);

    if (!['xn', 'n'].includes(_rpMqBreakpoints2.default.current().code)) {
        this._renderMoreMenu();
    }
};

/**
 * Get current visible items number
 * Show items, which fits actual container width
 * Move items, which doesn't fit actual container width, into the 'More' popover
 * Bind click handler to 'More' link
 * @private
 */
PrimaryMenu.prototype._renderMoreMenu = function () {
    var _this2 = this;

    var containerWidth = this.$obj.outerWidth();
    var itemsWidth = 0;
    var moreItems = [];

    this.items.forEach(function (item) {
        var width = item.getItemWidth();
        if (width === 0 || item.$obj.is(_this2.moreItemSelector)) {
            return false;
        }

        itemsWidth += width;
        if (itemsWidth >= containerWidth - _this2.$moreItem.outerWidth()) {
            moreItems.push(item.$obj);
        }
    });

    if (itemsWidth >= containerWidth) {
        this.$popoverList.append(moreItems);
    }

    if (this.$popoverList.find('li').length === 0) {
        this.$moreItem.detach();
    }

    this._changeSecondaryPointerPosition();
};

/**
 * Remove overflow hidden for primary menu container
 * @private
 */
PrimaryMenu.prototype._restoreOverflow = function () {
    this.$obj.addClass('rn-primaryNav_ready');
};

/**
 * Close Primary Navigation Hamburger Menu
 * @private
 */
PrimaryMenu.prototype._closeHamburgerMenu = function () {
    this.$obj.removeClass(this.primaryActiveClass);
    this.$hamburgerMenu.removeClass(this.hamburgerMenuActiveClass);
    (0, _jquery2.default)('html').css({
        'overflow-y': 'auto'
    });

    this.$overlay.remove();
    this.openedPrimary = false;

    (0, _jquery2.default)(document).off('click touchstart', '.ui-overlay');
};

/**
 * Opens Primary Navigation popover on exNarrow and narrow breakpoints
 * @private
 */
PrimaryMenu.prototype._openHamburgerMenu = function () {
    if (this.openedPrimary) {
        return;
    }
    this.$hamburgerMenu.addClass(this.hamburgerMenuActiveClass);

    (0, _jquery2.default)('html').css({
        'overflow-y': 'hidden'
    });

    this.$obj.addClass(this.primaryActiveClass);

    this.$parent.append(this.$overlay);
    this.openedPrimary = true;
    this._positionOverlay();

    var self = this;
    (0, _jquery2.default)(document).on('click touchstart', '.ui-overlay', function () {
        if (self.firstClickPrimary) {
            self.firstClickPrimary = false;
        } else {
            self._closeHamburgerMenu();
        }
    });
};

/**
 * Change the data/state of next-race in hamburger menu
 * @private
 */
PrimaryMenu.prototype._hamburgerMenuNextRace = function () {
    var link = window.location.protocol + '//' + window.location.host + '/racecards/next-race-data';
    var self = this;

    _jquery2.default.ajax({
        type: 'GET',
        url: link,
        dataType: 'json',
        success: function success(res) {
            var time_left_lable = res.time_left_lable,
                course_style_name = res.course_style_name,
                race_time = res.race_time,
                next_race_url = res.next_race_url;

            // next race URL is based on tab preference which is stored in localStorage

            var cardTabPrefCookie = localStorage.getItem('cdt_tab_pref');
            var cardTabToOpen = cardTabPrefCookie || 'free';
            var nextRaceUrl = cardTabToOpen === 'free' ? next_race_url + '/' : next_race_url + '/' + cardTabToOpen + '/';

            self.$hamburgerMenuNextRaceTimeLeft.text(time_left_lable);
            self.$hamburgerMenuNextRaceTimeAndCourse.text(race_time + ' ' + course_style_name);
            self.$hamburgerMenuNextRaceLink.attr('href', nextRaceUrl);
            self.$hamburgerMenuNextRaceSpanUnavailable.addClass(self.hamburgerMenuLinkHiddenClass);
            self.$hamburgerMenuNextRaceLink.removeClass(self.hamburgerMenuLinkHiddenClass);
        }
    });
};

/**
 * @private
 */
PrimaryMenu.prototype._positionOverlay = function () {
    this.$overlay.position({
        my: 'left top',
        at: 'left bottom',
        of: this.$overlayFrom.eq(0)
    });
};

/**
 * @private
 * @param {jQuery} $item
 * @returns {int}
 */
PrimaryMenu.prototype._getItemPointerPosition = function ($item) {
    return $item.offset().left + $item.outerWidth() / 2;
};

/**
 * @private
 */
PrimaryMenu.prototype._changeSecondaryPointerPosition = function () {
    if (!this.$secondaryPointer.is(':visible') || !this.getActiveItem()) {
        return;
    }

    var $currentItem = this.getActiveItem().$obj.children();

    if ($currentItem.closest(this.moreItemSelector).length !== 0) {
        $currentItem = this.$moreItem;
    }

    this.getNavigationContainer().trigger('changePointerPosition.secondaryNav', this._getItemPointerPosition($currentItem));
};

/**
 * Show 'More Sites' popover
 * Change appropriate classes for 'More' button
 * Bind click handler to elements outside the popover
 * @private
 */
PrimaryMenu.prototype._openMorePopover = function () {
    if (this.openedMore) {
        return;
    }

    this._restoreOverflow();

    this.$popover.addClass(this.morePopoverClass);
    this.$moreItemLink.addClass(this.primaryNavMoreLinkActiveClass).removeClass(this.linkUiClass);
    this.openedMore = true;

    (0, _jquery2.default)(document).on('click.rp.navigation.more touchstart.rp.navigation.more', this._onClickNavigationMoreHandler());
};

PrimaryMenu.prototype._onClickNavigationMoreHandler = function () {
    var self = this;

    return function (event) {
        if (self.firstClickMore) {
            self.firstClickMore = false;
        } else if (!self.$popover[0].contains(event.target)) {
            self._closeMorePopover();
        }
    };
};

PrimaryMenu.prototype.freeBets = function () {
    var _this3 = this;

    this.$freeBetsAnchors.each(function (_idx, el) {
        var $el = (0, _jquery2.default)(el);

        $el.on('click', function () {
            if ($el.hasClass(_this3.isAnchorInNavigation)) {
                segmentio.trackFreeBetsTap({});
            }
        });
    });
};

/**
 * Hide 'More Sites' popover
 * Change appropriate classes for 'More' button
 * Unbind click handler from elements outside the popover
 * @private
 */
PrimaryMenu.prototype._closeMorePopover = function () {
    this.$popover.removeClass(this.morePopoverClass);
    this.$moreItemLink.removeClass(this.primaryNavMoreLinkActiveClass).addClass(this.linkUiClass);
    this.openedMore = false;

    (0, _jquery2.default)(document).unbind('.rp.navigation.more');
};

function hasAnalyticsCookies() {
    return global.analytics && global.analytics.initialize;
}

function validateId(value) {
    return value === null || value === 'null' || value === 'undefined' ? null : value;
}

function isValidUserData(userData) {
    if (!userData || !userData.userTraits || !(0, _keys2.default)(userData).length || !(0, _keys2.default)(userData.userTraits).length) {
        return false;
    }

    return true;
}

function getRoleLabelText(userRole) {
    var role = (userRole || '').toLowerCase();
    var roleLabelMap = {
        free: 'Free account',
        insights: 'Insights',
        essential: 'Insights',
        tipping: 'Tipping',
        ultimate: 'Ultimate'
    };
    return roleLabelMap[role] || '';
}

function updateSubscribeButton(subscribeButton, userRole, menuType) {
    if (!subscribeButton) return;

    var role = (userRole || '').toLowerCase();
    var userId = (0, _rpUtils.getUserId)();
    var parentLink = subscribeButton.closest('a');

    if (!validateId(userId) && menuType === 'hamburger' || role === 'ultimate') {
        subscribeButton.style.display = 'none';

        return;
    }

    subscribeButton.style.display = 'inline-block';

    var upgradeRoles = ['insights', 'essential', 'tipping'];
    if (upgradeRoles.includes(role)) {
        subscribeButton.textContent = 'Upgrade';
        if (parentLink) parentLink.href = '/subscriptions/my-account/#tab=subscriptions';
    } else {
        subscribeButton.textContent = 'Subscribe';
        if (parentLink) parentLink.href = '/subscriptions/';
    }
}

function updateRoleLabel(plusIconSelector, labelClassName, userRole) {
    var plusIcons = document.querySelectorAll(plusIconSelector);
    var labelText = getRoleLabelText(userRole);

    plusIcons.forEach(function (img) {
        var nextEl = img.nextElementSibling;
        if (nextEl && nextEl.classList.contains(labelClassName)) {
            nextEl.remove();
        }

        if (!userRole) {
            img.style.display = 'none';
            return;
        }

        var roleLabel = document.createElement('span');
        roleLabel.className = labelClassName;
        roleLabel.textContent = labelText;
        img.insertAdjacentElement('afterend', roleLabel);

        if (userRole.toLowerCase() === 'free') {
            img.style.display = 'none';
            if (img.nextElementSibling) {
                img.nextElementSibling.classList.add('noLeftPadding');
            }
        } else {
            img.style.display = 'inline-block';
        }
    });
}

PrimaryMenu.prototype.updatePrimaryNavItems = function () {
    var padlockIcons = document.querySelectorAll('[data-padlock]');
    var subscribeButton = document.querySelector('.menu-subscribe-button');
    var plusIcons = document.querySelectorAll('.racing-post-plus-icon');

    (0, _rpUtils.getUserMetaData)().then(function (userData) {
        if (!isValidUserData(userData)) {
            plusIcons.forEach(function (img) {
                return img.style.display = 'none';
            });
            padlockIcons.forEach(function (img) {
                return img.style.display = 'none';
            });
            if (!hasAnalyticsCookies()) {
                padlockIcons.forEach(function (img) {
                    return img.style.display = 'none';
                });
            }
            if (subscribeButton) subscribeButton.classList.add('noLeftMargin');
            return;
        }

        var userRole = userData ? userData.userTraits.auth_role : null;
        var role = (userRole || '').toLowerCase();

        if (!role) {
            plusIcons.forEach(function (img) {
                return img.style.display = 'none';
            });
            document.querySelectorAll('.user-role-label').forEach(function (label) {
                label.style.display = 'none';
                label.style.textDecoration = 'none';
            });
            if (subscribeButton) subscribeButton.classList.add('noLeftMargin');
            return;
        }

        updateSubscribeButton(subscribeButton, role, 'primary');
        updateRoleLabel('.racing-post-plus-icon', 'user-role-label', role);

        var plusIcon = document.querySelector('.racing-post-plus-icon');

        if (plusIcon) {
            var label = plusIcon.nextElementSibling;

            if (role === 'free') {
                plusIcon.style.display = 'none';
                if (label) label.classList.add('noLeftPadding');
            } else {
                if (role === 'ultimate' && label) label.classList.add('noRightPadding');
                plusIcon.style.display = 'inline-block';
                updateRoleLabel('.racing-post-plus-icon', 'user-role-label', userRole);
            }
        }

        padlockIcons.forEach(function (img) {
            var userId = (0, _rpUtils.getUserId)();
            if (!role && userId) {
                img.style.display = 'none';
                return;
            }

            img.style.display = 'inline-block';
            var isHorseTracker = img.classList.contains('horse-tracker-padlock');
            if (isHorseTracker) {
                img.src = ['essential', 'insights', 'ultimate'].includes(role) ? '/svgs/padlock_unlocked.svg' : '/svgs/padlock_locked.svg';
            } else {
                img.src = role === 'ultimate' ? '/svgs/padlock_unlocked.svg' : '/svgs/padlock_locked.svg';
            }
        });
    }).catch(function (error) {
        console.error('Error fetching user metadata in updatePrimaryNavItems:', error);

        plusIcons.forEach(function (img) {
            return img.style.display = 'none';
        });
        padlockIcons.forEach(function (img) {
            return img.style.display = 'none';
        });
        document.querySelectorAll('.user-role-label').forEach(function (label) {
            label.style.display = 'none';
            label.style.textDecoration = 'none';
        });
        if (subscribeButton) subscribeButton.classList.add('noLeftMargin');
    });
};

PrimaryMenu.prototype.updateHamburgerMenuItems = function () {
    var userId = (0, _rpUtils.getUserId)();

    var freeBetsItem = document.querySelector('#free-bets-item');
    var subscribeItem = document.querySelector('#subscribe-item');

    if (freeBetsItem && subscribeItem) {
        if (validateId(userId)) {
            freeBetsItem.style.display = 'none';
            subscribeItem.style.display = 'flex';
        } else {
            freeBetsItem.style.display = 'block';
            subscribeItem.style.display = 'none';
        }
    }

    (0, _rpUtils.getUserMetaData)().then(function (userData) {
        var userRole = userData ? userData.userTraits.auth_role : null;
        var role = (userRole || '').toLowerCase();

        if (!role && subscribeItem) {
            subscribeItem.style.display = 'none';
        } else if (subscribeItem) {
            subscribeItem.style.display = 'flex';
        }

        // eslint-disable-next-line max-len
        var subscribeButtonHamburger = document.querySelector('.menu-subscribe-button-hamburger');
        updateSubscribeButton(subscribeButtonHamburger, userRole, 'hamburger');

        // eslint-disable-next-line max-len
        updateRoleLabel('.racing-post-plus-icon-hamburger', 'user-role-label-hamburger', userRole);

        var plusIconHamburger = document.querySelector('.racing-post-plus-icon-hamburger');
        if (role === 'free' && plusIconHamburger) {
            plusIconHamburger.style.display = 'none';
        } else if (plusIconHamburger) {
            plusIconHamburger.style.display = 'inline-block';
        }

        if (subscribeItem && role === 'ultimate') {
            var navLink = subscribeItem.querySelector('a');
            if (navLink) {
                navLink.removeAttribute('href');
                navLink.style.cursor = 'default';
                navLink.style.pointerEvents = 'none';
            }
        }

        var padlockIcons = document.querySelectorAll('[data-padlock]');
        padlockIcons.forEach(function (img) {
            if (!role && userId || !hasAnalyticsCookies()) {
                img.style.display = 'none';
            } else {
                img.style.display = 'inline-block';
                var isHorseTracker = img.classList.contains('horse-tracker-padlock');
                img.src = (isHorseTracker ? ['essential', 'insights', 'ultimate'].includes(role) : role === 'ultimate') ? '/svgs/padlock_unlocked.svg' : '/svgs/padlock_locked.svg';
                img.alt = role === 'ultimate' ? 'Unlocked icon' : 'Locked icon';
            }
        });
    }).catch(function (error) {
        console.error(error);

        if (subscribeItem) subscribeItem.style.display = 'none';
        document.querySelectorAll('[data-padlock]').forEach(function (img) {
            img.style.display = 'none';
        });
    });
};

exports.default = PrimaryMenu;


//////////////////
// WEBPACK FOOTER
// ./~/rp-navigation/lib/navigation/primaryMenu.js
// module id = 1073
// module chunks = 0